import { createReducer, on } from '@ngrx/store';
import * as fromPremiumRideAction from '../actions/premium-ride.action';

export const featureKey = 'premiumRide';

export interface State {
    premiumLines: {
        data: Array<any>,
        isLoaded: Boolean
    };
    selectedRoute: any,
    availablePremiumRide: {
        data: Array<any>,
        isLoaded: Boolean
    };
    availableMultipleRide: {
      data: Array<any>,
      details: any,
      isLoaded: Boolean
  };
    premiumBusActivity: {
      data: Array<any>,
      busInfo: any,
      isLoaded: Boolean
    };
}

export const initialState: State = {
    premiumLines: {
        data: [],
        isLoaded: false
    },
    selectedRoute: null,
    availablePremiumRide: {
        data: [],
        isLoaded: false
    },
    availableMultipleRide: {
      data: [],
      details: null,
      isLoaded: false
  },
    premiumBusActivity: {
      data: [],
      busInfo: null,
      isLoaded: false
  },
};

export const reducer = createReducer(
  initialState,  
  on(fromPremiumRideAction.getPremiumLinesSuccess, (state: State, props: any) => ({
    ...state,
    premiumLines: {data: props.data, isLoaded: true}
  })),
  on(fromPremiumRideAction.findRideSuccess, (state: State, props: any) => ({
    ...state,
    selectedRoute: props.selectedRoute
  })),
  on(fromPremiumRideAction.findRideSuccess, (state: State, props: any) => ({
    ...state,
    availablePremiumRide: {data: props.data, isLoaded: true}
  })),
  on(fromPremiumRideAction.getPremiumBusActivitySuccess, (state: State, props: any) => ({
    ...state,
    premiumBusActivity: {data: props.data, busInfo: props.busInfo, isLoaded: true}
  })),
  on(fromPremiumRideAction.findMultipleRidesSuccess, (state: State, props: any) => ({
    ...state,
    availableMultipleRide: {data: props.data, details: props?.details, isLoaded: true}
  })),
);
